import React from "react";
import AgentDetailsContainer from '../containers/AgentDetails';
import Header from '../containers/Header';

function AgentDetails() {

  return (
    <div>
      <Header />
      <AgentDetailsContainer />
    </div>

  );
}

export default AgentDetails;